import { api } from './client';
import type { DashboardQuery, DashboardResponse } from '../types/dashboard';

export const dashboardApi = {
  get: (query: DashboardQuery) =>
    api.get<DashboardResponse>('/dashboard', { params: query }).then((r) => r.data),
};
